// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import axios from 'axios'
import App from './App';
import router from './router';
import { setupComponents } from './config/setup-components';
import setupApi from './services/api';

Vue.config.productionTip = false;
Vue.prototype.$http  =  axios;
Vue.prototype.$apiUrl = 'https://si.stratis.pro';

setupComponents(Vue);
setupApi(Vue);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  data: {
    themeColor: '#B4B2B1',
    apiUrl: 'https://si.stratis.pro'
  }
});


// WEBPACK FOOTER //
// ./src/main.js